// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  height: 160px;
  padding-bottom: 0px;
  margin-bottom: 30px;
  border-bottom: 4px solid #dfe1e3;
  padding: 1.2rem 1rem;
}

.navbar-wrapper {
  position: relative;
  width: 1300px;
  margin: 0 auto;
}

.top-links {
  position: absolute;
  bottom: 10px;
  right: 0px;
  list-style: none;
}
.top-links a {
  padding-left: 10px;
}

.top-links a:hover {
  color: #6f6f6f;
}

.search-wrapper {
  position: absolute;
  right: 0;
  bottom: 0;
}

.nav-link {
  padding-left: 0 !important;
  padding-right: 30px !important;
  font-size: 16px;
  color: #6f6f6f;
}

.nav-link:hover {
  color: #03881c;
  /* text-decoration: underline; */
}

.paituli-logo {
  position: relative;
  padding-top: 14px;
  float: left;

  font-weight: bold;
  color: #0075a3;
  font-size: 48px;
}

.paituli-logo:hover {
  color: #0075a3;
}

.navbar-header {
  height: 100px;
}

.avaa-logo img {
  margin-right: -15px;
  padding-top: 9px;
  width: 350px;
  float: right;
}

.logo-wrapper {
  width: 400px;
}

.active-tab {
  position: relative;
  top: 9px;
  height: 3px;
  background-color: #03881c;
  width: calc(100% - 30px);
  display: none;
}

.active-tab.active {
  display: block;
}

.nav-link.active {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./css/header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;;EAEX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".navbar {\n  height: 160px;\n  padding-bottom: 0px;\n  margin-bottom: 30px;\n  border-bottom: 4px solid #dfe1e3;\n  padding: 1.2rem 1rem;\n}\n\n.navbar-wrapper {\n  position: relative;\n  width: 1300px;\n  margin: 0 auto;\n}\n\n.top-links {\n  position: absolute;\n  bottom: 10px;\n  right: 0px;\n  list-style: none;\n}\n.top-links a {\n  padding-left: 10px;\n}\n\n.top-links a:hover {\n  color: #6f6f6f;\n}\n\n.search-wrapper {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n\n.nav-link {\n  padding-left: 0 !important;\n  padding-right: 30px !important;\n  font-size: 16px;\n  color: #6f6f6f;\n}\n\n.nav-link:hover {\n  color: #03881c;\n  /* text-decoration: underline; */\n}\n\n.paituli-logo {\n  position: relative;\n  padding-top: 14px;\n  float: left;\n\n  font-weight: bold;\n  color: #0075a3;\n  font-size: 48px;\n}\n\n.paituli-logo:hover {\n  color: #0075a3;\n}\n\n.navbar-header {\n  height: 100px;\n}\n\n.avaa-logo img {\n  margin-right: -15px;\n  padding-top: 9px;\n  width: 350px;\n  float: right;\n}\n\n.logo-wrapper {\n  width: 400px;\n}\n\n.active-tab {\n  position: relative;\n  top: 9px;\n  height: 3px;\n  background-color: #03881c;\n  width: calc(100% - 30px);\n  display: none;\n}\n\n.active-tab.active {\n  display: block;\n}\n\n.nav-link.active {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
